export const theme = {
  bodyContentColor: Styles.color.grey.one,
};
